import type { FC } from 'react'

import { Th } from '@skytech/ui/Table/Th'
import CheckboxBlankOutlineIcon from 'mdi-react/CheckboxBlankOutlineIcon'
import CheckboxMarkedOutlineIcon from 'mdi-react/CheckboxMarkedOutlineIcon'
import MinusBoxOutlineIcon from 'mdi-react/MinusBoxOutlineIcon'

import { useTranslation } from '@/app/translations/translations-hooks'

export const AllAssetsCheckbox: FC<{
  className: string
  isSelected: boolean
  isAllSelected: boolean
  onClick: () => void
}> = ({ className, isSelected, isAllSelected, onClick }) => {
  const translate = useTranslation()
  return (
    <Th className={className}>
      <div title={translate('Select all')}>
        {isSelected && isAllSelected ? (
          <CheckboxMarkedOutlineIcon onClick={() => onClick()} />
        ) : isSelected ? (
          <MinusBoxOutlineIcon onClick={() => onClick()} />
        ) : (
          <CheckboxBlankOutlineIcon onClick={() => onClick()} />
        )}
      </div>
    </Th>
  )
}
